<template>
  <div class="main container">

    <div class="logo col-md-12 text-center">
      <img src="./../../assets/logo-10.png">
    </div>
    <div class="col-md-12 text-center">
      <h4 class="highlight-color">{{ $t('message.register') }}</h4>
      <p class="highlight-color">{{ $t('message.intro2') }}</p>
    </div>

    <!-- <stepprogress-view
      :steps="progress.steps"
      :active="progress.active"
      class="pt-2"
      style="max-width: 600px;margin: auto;"/> -->

    <div
      v-if="$store.state.app.error_message"
      class="col-md-6 form p-0"
      style="background: none;">
      <div
        class="alert alert-danger m-0"
        role="alert">
        <span v-if="$store.state.app.error_message == 'This email is already taken'">{{ $t('message.thisemailisalreadytaken') }}</span>
        <span v-else-if="$store.state.app.error_message == 'I was expecting at least 6 chars in password'">{{ $t('message.passwordmustbeatleast6characters') }}</span>
        <span v-else>{{ $store.state.app.error_message }}</span>
      </div>
    </div>

    <template v-if="progress.active == 0">
      <div class="col-md-6 form">
        <div class="form-group">
          <label>{{ $t('message.labelstoreandcompany') }}</label>
          <input
            ref="shop_name"
            :class="[{'is-invalid': state.is_invalid_shop_name}]"
            v-model="form.shop_name"
            type="text"
            class="form-control"
            @keyup="form.shop_name.trim().length == 0 ? state.is_invalid_shop_name = true : state.is_invalid_shop_name = false">
        </div>
        <div class="form-group">
          <label>{{ $t('message.busform') }}:</label>
          <div class="mt-1">
            <vs-radio
              v-model="form.business_form_id"
              style="justify-content: left;margin: 0;font-size: var(--font-size);"
              vsValue="1">
              {{ $t('business.form.1') }}
            </vs-radio>
          </div>
          <div class="mt-2">
            <vs-radio
              v-model="form.business_form_id"
              style="justify-content: left;margin: 0;font-size: var(--font-size);"
              vsValue="2">
              {{ $t('business.form.2') }}
            </vs-radio>
          </div>
        </div>
        <!-- <div class="form-group">
          <label>{{ $t('message.tel') }}</label>
          <input
            v-model="form.tel"
            type="text"
            class="form-control">
        </div> -->
        <!-- <div class="form-group">
          <label>{{ $t('message.address') }}</label>
          <textarea
            v-model="form.address"
            class="form-control"/>
        </div> -->
        <div
          v-if="hasRefCode"
          class="form-group">
          <hr>
          <label>{{ $t('message.codediscount') }}:</label>
          <div>
            <input
              :disabled="true"
              :value="$route.query.refcode"
              type="text"
              class="form-control">
          </div>
          <div
            class="mt-2"
            style="font-size: 13px;">
            <p v-if="partner.loading">
              {{ $t('message.checkingcodediscount') }}
            </p>
            <p
              v-else-if="hasPartnerId"
              v-html="$t('message.codediscountisvalid', {
                discount_rate: partner.discountRate,
                month_period: partner.discountMonthPeriod,
            })"/>
            <p v-else>
              {{ $t('message.codediscountisinvalid') }}
            </p>
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t('message.business_type') }}:</label>
          <select
            v-model="form.business_type_code"
            class="form-select custom-select">
            <option :value="null">
              {{ $t('placeholder.select') }}
            </option>
            <template v-if="form.business_form_id == '1'">
              <optgroup
                v-for="(group, groupIndex) of business_form_option_store"
                :key="groupIndex"
                :label="group.label">
                <option
                  v-for="(option, optionIndex) in group.options"
                  :key="optionIndex"
                  :value="option.value">{{ option.text }}</option>
              </optgroup>
            </template>
            <template v-else>
              <option
                v-for="(option, index) of business_form_option_compay"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </template>
            <option value="custom">
              {{ $t('message.otherbusinesstype') }}
            </option>
          </select>
          <input
            v-if="form.business_type_code == 'custom'"
            ref="custom-bus-type"
            v-model="form.business_type_code_custom"
            type="text"
            class="form-control mt-2"
          >
        </div>
        <div
          v-if="(form.business_type_code && form.business_type_code != 'custom') || form.business_type_code_custom != null"
          class="form-group">
          <label>{{ $t('message.recommendedapps') }}:</label>
          <div
            class="d-flex flex-column mt-1"
            style="gap: 8px;">
            <BaseCheckbox
              v-model="form.interesting.POS"
              :label="$t('business.interesting.POS')"
              value="POS"
            />
            <BaseCheckbox
              v-model="form.interesting.MENU_ONLINE"
              :label="$t('business.interesting.MENU_ONLINE')"
              value="MENU_ONLINE"
            />
            <BaseCheckbox
              v-model="form.interesting.INVENTORY"
              :label="$t('business.interesting.INVENTORY')"
              value="INVENTORY"
            />
            <BaseCheckbox
              v-if="form.business_form_id == '2'"
              v-model="form.interesting.SO_PO_INV"
              :label="$t('business.interesting.SO_PO_INV')"
              value="SO_PO_INV"
            />
            <BaseCheckbox
              v-if="form.business_form_id == '2'"
              v-model="form.interesting.CRM"
              :label="$t('business.interesting.CRM')"
              value="CRM"
            />
            <BaseCheckbox
              v-model="form.interesting.ACCOUNTING"
              :label="$t('business.interesting.ACCOUNTING')"
              value="ACCOUNTING"
            />
            <BaseCheckbox
              v-if="form.business_form_id == '2'"
              v-model="form.interesting.HRM_PAYROLL"
              :label="$t('business.interesting.HRM_PAYROLL')"
              value="HRM_PAYROLL"
            />
            <BaseCheckbox
              v-model="form.interesting.REPORT"
              :label="$t('business.interesting.REPORT')"
              value="REPORT"
            />
            <BaseCheckbox
              v-model="form.interesting.USER_PERMISSION"
              :label="$t('business.interesting.USER_PERMISSION')"
              value="USER_PERMISSION"
            />
          </div>
        </div>
        <hr >
        <div class="form-row">
          <div class="col-6"/>
          <div class="col-6">
            <button
              :disabled="form.shop_name.trim().length == 0"
              type="submit"
              class="btn btn-secondary btn-block"
              @click="progress.active = 1">
              {{ $t('button.next') }}
              <i
                class="fas fa-angle-right"
                style="position: relative;top: 1px;"/>
            </button>
          </div>
        </div>
      </div>
    </template>

    <template v-if="progress.active == 1">
      <div class="col-md-6 form">
        <div class="form-group">
          <label>{{ $t('message.email') }}</label>
          <input
            ref="email"
            :class="[{'is-invalid': state.is_invalid_email}]"
            :disabled="$store.state.app.loading == true || disabledForm"
            v-model="form.email"
            type="email"
            class="form-control"
            @keyup="form.email.trim().length == 0 ? state.is_invalid_email = true : state.is_invalid_email = false;"
            @change="!validateEmail(form.email) ? state.is_invalid_email = true : state.is_invalid_email = false">
          <div class="invalid-feedback">
            {{ $t('message.emailisinvalid') }}
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t('message.password') }}</label>
          <template>
            <input
              v-if="browser.name == 'chrome'"
              :class="[{'is-invalid': state.is_invalid_password}]"
              :disabled="$store.state.app.loading == true || disabledForm"
              v-model="form.password"
              type="text"
              class="form-control text-security"
              @change="form.password.trim().length < 6 ? state.is_invalid_password = true : state.is_invalid_password = false">
            <input
              v-else
              :class="[{'is-invalid': state.is_invalid_password}]"
              :disabled="$store.state.app.loading == true || disabledForm"
              v-model="form.password"
              type="password"
              class="form-control"
              @change="form.password.trim().length < 6 ? state.is_invalid_password = true : state.is_invalid_password = false">
          </template>
          <div class="invalid-feedback">
            {{ $t('message.passwordmustbeatleast6characters') }}
          </div>
        </div>
        <div class="">
          <vs-checkbox
            :disabled="$store.state.app.loading == true || disabledForm"
            v-model="form.agree_terms"
            :vsValue="true"
            style="justify-content: left;margin: 0;font-size: var(--font-size);" >
            {{ $t('message.iagreeterms') }}
            <a
              href="https://www.treesoft.io/th/terms"
              target="_blank"
              style="position: relative;z-index: 999999;">
              {{ $t('message.terms') }}
            </a>
          </vs-checkbox>
        </div>
        <hr >
        <div
          v-if="!isSubmitted"
          class="form-row mt-3">
          <div class="col-6">
            <button
              :disabled="$store.state.app.loading"
              type="submit"
              class="btn btn-secondary btn-block"
              @click="progress.active = 0">
              <i
                class="fas fa-angle-left"
                style="position: relative;top: 1px;"/>
              {{ $t('button.prev') }}
            </button>
          </div>
          <div class="col-6">
            <button
              :disabled="disabledRegister"
              type="submit"
              class="btn btn-web btn-block"
              @click="register()">
              <span v-if="$store.state.app.loading"><i class="fas fa-spinner spin"/></span>
              <span v-else>{{ $t('message.login') }}</span>
            </button>
          </div>
        </div>
        <div
          v-else
          class="form-row d-flex flex-column align-items-center justify-content-center mt-3">
          <CircleProgress
            :percent="myLoading.progress"
            :size="60"
            :viewport="true"
            :showPercent="false"
            :borderBgWidth="5"
            :borderWidth="5"
            fillColor="#A3CA76"
          />
          <div
            class="mt-2 text-center"
            v-html="$t('message.registerloading')"/>
        </div>
      </div>
    </template>

    <template v-if="progress.active == null">
      <div class="col-md-6 form">
        <p class="text-success text-center">
          {{ $t('message.registersuccess') }} <i class="far fa-check-circle"/>
        </p>
        <div
          class="fb-page"
          data-href="https://www.facebook.com/treesoft.io"
          data-tabs=""
          data-width=""
          data-height=""
          data-small-header="true"
          data-adapt-container-width="true"
          data-hide-cover="true"
          data-show-facepile="false"><blockquote
            cite="https://www.facebook.com/treesoft.io"
            class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/treesoft.io">TreeSoft.io</a></blockquote></div>
      </div>
    </template>

    <div
      v-if="progress.active == 0"
      class="col-md-12 text-center mb-4">
      <p class="text-white mb-1">
        {{ $t('message.alreadyaccount') }}
        <router-link
          :to="{
            name: 'SignIn',
            query: {
              ...$route.query,
            }
          }"
          class="text-white">
          {{ $t('message.login') }}
        </router-link>
      </p>
      <DropdownLang/>
    </div>

    <div
      v-if="progress.active == null"
      class="col-md-12 text-center mb-4">
      <p class="text-white mb-1">
        <router-link
          :to="{
            name: 'SignIn',
            query: {
              'token': form.token
            }
          }"
          class="text-white">
          {{ $t('message.login') }}
        </router-link>
      </p>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import stepprogressView from '@/components/custom/StepProgress.vue'
import TSPartnerService from '../../api/TSPartnerService'
import CircleProgress from '../custom/CircleProgress.vue'
import loadingMixin from '@/mixins/loading'
import DropdownLang from '../custom/DropdownLang.vue'
const jwt = require('jsonwebtoken')

export default {
  name: 'SignUp',
  components: {
    stepprogressView,
    CircleProgress,
    DropdownLang,
  },
  mixins: [loadingMixin],
  data () {
    return {
      form: {
        shop_name: '',
        business_form_id: '1',
        business_type_code: null,
        business_type_code_custom: null,
        email: '',
        password: '',
        tel: '',
        address: '',
        agree_terms: false,
        token: null,
        interesting: {
          POS: false,
          MENU_ONLINE: false,
          INVENTORY: false,
          SO_PO_INV: false,
          CRM: false,
          ACCOUNTING: false,
          HRM_PAYROLL: false,
          REPORT: false,
          USER_PERMISSION: false,
        },
      },

      progress: {
        steps: [],
        active: 0,
      },

      state: {
        is_invalid_shop_name: false,
        is_invalid_email: false,
        is_invalid_password: false,
      },

      partner: {
        partnerId: null,
        discountRate: 0,
        discountMonthPeriod: 0,
        loading: false,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
    isValidEmail () {
      return this.validateEmail(this.form.email)
    },
    disabledRegister () {
      return this.form.email.trim().length == 0 ||
             this.isValidEmail === false ||
             this.form.password.trim().length == 0 ||
             this.form.agree_terms == false ||
             this.$store.state.app.loading ||
             this.state.is_invalid_email == true ||
             this.state.is_invalid_password == true
    },
    hasRefCode() {
      return this.$route.query.refcode
    },
    hasPartnerId() {
      return this.partner.partnerId
    },
    business_form_option_store() {
      return [
        {
          label: this.$t('business.type_code.1100.label'),
          options: [
            {
              text: this.$t('business.type_code.1100.1101'),
              value: '1101',
            },
            {
              text: this.$t('business.type_code.1100.1102'),
              value: '1102',
            },
            {
              text: this.$t('business.type_code.1100.1103'),
              value: '1103',
            },
            {
              text: this.$t('business.type_code.1100.1104'),
              value: '1104',
            },
          ],
        },
        {
          label: this.$t('business.type_code.1200.label'),
          options: [
            {
              text: this.$t('business.type_code.1200.1201'),
              value: '1201',
            },
            {
              text: this.$t('business.type_code.1200.1202'),
              value: '1202',
            },
            {
              text: this.$t('business.type_code.1200.1203'),
              value: '1203',
            },
            {
              text: this.$t('business.type_code.1200.1204'),
              value: '1204',
            },
            {
              text: this.$t('business.type_code.1200.1205'),
              value: '1205',
            },
          ],
        },
        {
          label: this.$t('business.type_code.1300.label'),
          options: [
            {
              text: this.$t('business.type_code.1300.1301'),
              value: '1301',
            },
            {
              text: this.$t('business.type_code.1300.1302'),
              value: '1302',
            },
          ],
        },
        {
          label: this.$t('business.type_code.1400.label'),
          options: [
            {
              text: this.$t('business.type_code.1400.1401'),
              value: '1401',
            },
          ],
        },
      ]
    },
    business_form_option_compay() {
      return [
        {
          text: this.$t('business.type_code.2100'),
          value: '2100',
        },
        {
          text: this.$t('business.type_code.2200'),
          value: '2200',
        },
        {
          text: this.$t('business.type_code.2300'),
          value: '2300',
        },
      ]
    },
    disabledForm() {
      return this.isSubmitted
    },
  },
  watch: {
    'progress': {
      handler: function () {
        let progress = this.progress
        switch (progress.active) {
          case 0:
            this.$nextTick(function () {
              this.$refs.shop_name.focus()
            })
            break
          case 1:
            this.$nextTick(function () {
              this.$refs.email.focus()
            })
            break
        }
      },
      deep: true,
    },
    'form.business_form_id': {
      handler: function() {
        this.form.business_type_code = null
      },
      deep: true,
    },
    'form.business_type_code': {
      handler: function() {
        if (this.form.business_type_code == 'custom') {
          this.$nextTick(() => {
            this.$refs['custom-bus-type'].focus()
          })
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.$route.query.app == 'apps.inventory') {
      return this.$router.push({
        name: 'SignIn',
        query: {
          ...this.$route.query,
        },
      })
    }

    this.$nextTick(function () {
      this.$refs.shop_name.focus()
    })

    // add steps
    this.progress.steps.push(this.$t('message.aboutbusiness'))
    this.progress.steps.push(this.$t('message.useraccount'))
    this.progress.steps.push(this.$t('message.success'))

    if (this.hasRefCode) {
      this.partner.loading = true
      const response = await TSPartnerService.getPartnerDiscount(this.$route.query.refcode)
      if (response.data.data != null && response.data.data.is_verified == true) {
        this.partner.partnerId = response.data.data.partner_id
        this.partner.discountRate = response.data.data.discount_rate
        this.partner.discountMonthPeriod = response.data.data.discount_month_period
      }
      this.partner.loading = false
    }
  },
  mounted: function () {
    // set section
    this.$store.dispatch('setSection', 'login')
    // set title
    this.setTabTitle(this.$t('message.title_signup'))
  },
  methods: {
    async register () {
      this.isSubmitted = true

      const dataSet = {
        'email': this.form.email.trim().toLowerCase(),
        'password': this.form.password,
        'shop_name': this.form.shop_name.trim(),
        'tel': this.form.tel.trim(),
        'address': this.form.address.trim(),
        'business_form_id': parseInt(this.form.business_form_id),
        'business_type_code': this.form.business_type_code,
        'business_type_code_custom': this.form.business_type_code_custom,
        'interesting': this.form.interesting,
        'lang_code': this.lang,
      }

      if (Object.keys(this.$route.query).length) {
        dataSet['url_query_params'] = {
          ...this.$route.query,
        }
      }

      if (this.hasPartnerId) {
        dataSet['partner_id'] = this.partner.partnerId
      }

      let res = await this.$store.dispatch('Register', dataSet)

      if (res.success) {
        await this.startProgress()

        // complate step
        this.progress.active = null

        // set token
        let payload = {
          'email': this.form.email,
          'password': this.form.password,
        }
        this.form.token = jwt.sign(payload, this.project.config.token.secret, { expiresIn: '1h' })

        // for facebook like button
        this.$nextTick(function () {
          try {
            FB.XFBML.parse()
          } catch (ex) {}
        })

        this.$router.push({
          name: 'SignIn',
          query: {
            'token': this.form.token,
          },
        })
      } else {
        this.isSubmitted = false
      }
    },
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)

      // set progress steps
      this.progress.steps = []
      this.progress.steps.push(this.$t('message.aboutbusiness'))
      this.progress.steps.push(this.$t('message.useraccount'))
      this.progress.steps.push(this.$t('message.complete'))
    },
  },
}
</script>

<style scoped>
.logo {
  margin: 25px 0 25px 0;
}
.form {
  padding: 25px 25px 20px 25px;
  max-width: 400px;
  margin: 25px auto;
  background: #FFF;
  border-radius: 2px;
  font-size: 14px;
}
.text {
  color: #282D35;
}
a {
  text-decoration: underline;
}
.text-security {
  -webkit-text-security: disc;
}
</style>



// WEBPACK FOOTER //
// src/components/account/SignUp.vue